module.exports = __webpack_public_path__ + "img/women-icon.f32dd99c.png";